import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import ProductPage from './ProductPage';
import ProductDetail from './ProductDetail';
import DemoFeaturesPage from './DemoFeaturesPage';

type TParams = { id: string, url: string }

function Products({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
            <Route exact path={`${match.url}`} component={ProductPage} />
            <Route exact path={`${match.url}/demo`} component={DemoFeaturesPage} />
            <Route exact path={`${match.url}/:productId`} component={ProductDetail} />
        </Switch>
    );
}

export default Products;
